import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '@Sagas';
import RootReducer from '@Reducers';

const middleware = [];
const sagaMiddleware = createSagaMiddleware();
middleware.push(sagaMiddleware);
const store = createStore(
  RootReducer,
  compose(applyMiddleware(...middleware)),
);
sagaMiddleware.run(rootSaga);
export default store;
